import { GetTheApp } from '../../auth/components/start-membership/GetTheApp';

export default function GetTheAppPage() {
    return <GetTheApp />;
}
